import * as React from "react";
import PickersTextField from "./PickersTextField";
import { DateRangePicker as MaterialDateRangePicker, DateRangePickerProps as MaterialDateRangePickerProps } from "@mui/x-date-pickers-pro";

interface DateRangePickerProps extends MaterialDateRangePickerProps {
    label?: string;
    error?: boolean;
    helperText?: string;
}

const DateRangePicker: React.FunctionComponent<DateRangePickerProps> = React.forwardRef((props: DateRangePickerProps, ref: any) => {
    const { slots: _slots, label, error, helperText, ...rest } = props;

    const slots = React.useMemo(() => {
        return {
            textField: (params) => <PickersTextField {...params} label={label} size="small" fullWidth error={error} helperText={helperText} />,
            ..._slots,
        };
    }, [_slots])

    return <MaterialDateRangePicker 
        ref={ref}
        format="dd/MM/yyyy"
        slots={slots}
        slotProps={{ field: { dateSeparator: 'to' } }}
        {...rest}
    />;
});

export default DateRangePicker;